import React from 'react'

import styles from '../assets/styles/styles.module.css'
import { PText } from '@porsche-design-system/components-react';
import { RatingContext } from '../utils/RatingContext'
import { TEXT } from '../i18n/text'

export const FooterSection = (): React.ReactElement => {

    const language = React.useContext(RatingContext).language

    return (
        <footer>
            <div className={styles.links}>
                <PText size='x-small'>
                    <a href='https://www.porsche.com/germany/legal-notice/' target='_blank' rel='noopener noreferrer'>{TEXT[language].imprint}</a></PText>
            </div>
        </footer>
    )
}